"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenAndJoinNodes = flattenAndJoinNodes;
var _react = _interopRequireDefault(require("react"));
var _flattenNodes = _interopRequireDefault(require("./flattenNodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function flattenAndJoinNodes({
  children,
  direction = 'vertical',
  divider,
  gap,
  renderItem,
  ItemWrapper,
  Spacer
}) {
  let finalChildren = [];
  const itemsToJoin = [];
  const shouldJoin = gap !== undefined || divider !== undefined;
  const childrenAsArray = _react.default.Children.toArray(children);
  const flattenedChildren = shouldJoin || childrenAsArray.length > 1 ? (0, _flattenNodes.default)(childrenAsArray) : undefined;
  if (gap) {
    itemsToJoin.push( /*#__PURE__*/_react.default.createElement(Spacer, {
      [direction]: gap
    }));
  }
  if (divider) {
    const Divider = divider;
    itemsToJoin.push( /*#__PURE__*/_react.default.createElement(Divider, null));
  }
  const childrenContents = flattenedChildren ? flattenedChildren.map((item, index) => renderItem && ItemWrapper ? renderItem({
    item,
    Wrapper: ItemWrapper,
    index,
    isFirst: index === 0,
    isLast: flattenedChildren.length - 1 === index
  }) : item) : childrenAsArray;
  if (shouldJoin) {
    childrenContents.forEach((item, index) => {
      // The last item doesn't include divider or spacer
      if (index === childrenContents.length - 1) {
        finalChildren = [...finalChildren, item];
      } else {
        finalChildren = [...finalChildren, item, ...itemsToJoin];
      }
    });
    return _react.default.Children.toArray(finalChildren);
  }
  return childrenContents;
}